import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Warning from "../components/Warning";
import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

const Lost = () => {
  return (
    <div className="App" style={{ margin: "-8px" }}>
      <HelmetProvider>
        <Helmet>
          <title>Servers and Services</title>
          <meta
            name="Foredark Games"
            content="Foredark Games"
            description="Foredark Games Video Games"
            author="Jack Frederick"
          />
        </Helmet>
      </HelmetProvider>
      <Warning></Warning>
      <Navbar></Navbar>
      <header className="Home">
        <p className="Homethick">
          Foredark Games
        </p>
        <br></br>
        <p className="Homethick-sm">
          Current Project: Code Name "Elysium"
        </p>
        <p className="Homesmall">
          The game is currently in development, and is not available to the public yet.
        </p>
        <br></br>
        <br></br>
        <a className="Homesmall ats" style={{ color: "black" }} href="https://steamcommunity.com/id/Foredark_Games">
          Steam Page
        </a>
        <br></br>
        <br></br>
        <a className="Homesmall ats" style={{ color: "black" }} href="https://youtube.com/@engineering_jack">
          Devlogs
        </a>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <a className="Homesmall ats" style={{ color: "black" }} href="/">
          Go Back Home
        </a>

      </header>
      <Footer></Footer>
    </div>
  );
};

export default Lost;
